import { FC } from 'react';
// component
import AddUserComponent from 'components/main/Users/Add';

const AddUser: FC = () => <AddUserComponent />;

export default AddUser;
